//-------------------------------------------------------------------------------
// Four HOCs so every component can consume wrappers to connect to the store,
// translations, register all loaded instances of ag-grid to force a re-render,
// or bring a component into the dedicated modal box wrapper.
//
// Load Polyfills before rendering the app (promise-based).
//
// Attach React to #ifg-id-verification-portal.
//
// Scoped stylesheet contains global-level basic styles for all tags and for the
// app container that is not displayed on load. Vanilla js takes care of it in sagas --------- XXXXX >>>>>>
// --------- XXXXX >>>>>> HAS TO BE REVIEWED CAUSE I THINK IT SHOULD BE MANAGED BY REACT ---- THE WHOLE PRELOADER
// THINGY HAS TO BE REVIEWED.
//-------------------------------------------------------------------------------

//-------------------------------------------------------------------------------
// Import Directives
//-------------------------------------------------------------------------------

import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';

import i18n from '@/assets/js/utilities/i18n.config';
import loadPolyfills from '@/assets/js/utilities/loadPolyfills';
const IDVerificationApp = lazy(() => import('./components/IDVerificationApp'));

import './main.scss';

//-------------------------------------------------------------------------------
// React Render Call in a promise with browser sniffing first in order
// to load polyfills if needed.
//
//-------------------------------------------------------------------------------

loadPolyfills().then(() => {
  ReactDOM.render(
    <I18nextProvider i18n={i18n}>
      <Suspense fallback="">
        <IDVerificationApp />
      </Suspense>
    </I18nextProvider>,
    document.getElementById('ifg-id-verification-portal'),
  );
});
